import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { EntityType } from 'src/app/models/mocks/ivr.enym';
import { AlertService, CommonService, PatPreDrugModalService, UserService } from 'src/app/services';
import { CommonUtil, RxUtils } from 'src/app/utils';
import { DateCheckUtil } from 'src/app/utils/date-checks.util';
import { PatientComponent } from '../../patient/patient.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MsgConfig } from 'src/app/app.messages';
import * as moment from 'moment';
import { MessageService } from 'src/app/services/message.service';
import { CommonStore } from 'src/app/store';
import { v4 as uuid } from 'uuid';
@Component({
  selector: 'app-communication-info-pop-up',
  templateUrl: './communication-info-pop-up.component.html',
  styleUrl: './communication-info-pop-up.component.scss',
  standalone: false
})
export class CommunicationInfoPopUpComponent implements OnInit {
  @Output() IsPopUpClosed = new EventEmitter<any>();
  @ViewChild("searchBoxInsType", { static: true }) searchBoxInsType: ElementRef;
  unsubscribe$: Subject<void> = new Subject();  
  callLogFG:FormGroup;
  callModeList : any;
  callDirectionList: any;
  callReasonsList: any;
  @Input() CallLogDetails;
  @Input() PhUsername;
  @Input() IsOutbondCall;
  @Input() IsCallMode;
  @Input() PhoneNumber;
  @Input() Recipient;
  @Input() PatientDetails;
  @Input() IsFrom;
  @Input() IsfromManual;
  @Input() RxInfo;
  @Input() IsfromComms;
  @Input() IsfromCallLog;
  @Input() UpdateCallLogDetails;
  @Input() IsEditCallLog;
  @Input() IsMaxScreen;
  @Input() IsfromInbound;
  @Input() InboundDetails;
  @Input() PatientInfo;
  today: any;
  isInputFocused;
  clearpatName: boolean = true;
  checkPat: boolean;
  speakingWithList: any;
  Spcktype = 1;
  prescInputValue : boolean = true;
  insuName: any = "";
  inputValue: any = "";
  insuranceData: any;
  modelRef: any;
  errorToDisplay: any;
  callLogId: any;
  callDirecion: any;
  patientHistRef: any;
  maxDate: { year: number; month: number; day: number; };
  isSelectReason: boolean;
  popupId = uuid();
  @HostListener("window:keydown", ["$event"])
      keyEventAlt(event: KeyboardEvent) {
      const topPopup = this._commonUtil.getTopPopup();
      if (topPopup === this.popupId) {
          if (event.which === 27) {
              this.cancelModal();
              event.preventDefault();
          }
        }
    }
  constructor(private _cmnSvc: CommonService, private _commonUtil: CommonUtil, private _cdr: ChangeDetectorRef, private _fb: FormBuilder, private _dateCheckUtil: DateCheckUtil, private _msgServ: MessageService,
    private _userServ: UserService, private ngZone: NgZone, private _mdlServ: NgbModal, private _patPreDrugService: PatPreDrugModalService, private _alrtSvc: AlertService,private _rxUtils: RxUtils, private _cmmStore : CommonStore
    
  ) {}

  ngOnInit() {
    this._commonUtil.open(this.popupId);
    const callReasonsList = this._cmnSvc.callerReasons$["source"]["value"] ? [...this._cmnSvc.callerReasons$["source"]["value"]] : [];
      if(callReasonsList?.length) {
        this.callReasonsList = [...callReasonsList]
      } else {
          this.getCallerReason();
      }
    this.today = this._dateCheckUtil.getCurrentDateWithTime();    
    this.defaultPatchings(); 
    this._cmmStore._signlrInboundData$.pipe(takeUntil(this.unsubscribe$)).subscribe(val => {
        if(val) {
            const storedValue = localStorage.getItem("IvrGUIDDetails");
            let ivrDetails = this._cmnSvc.getIvrGUIDDetails(storedValue, this._cmnSvc.DecryptData(localStorage.getItem('SfaxEncryptionVector')));
            this.callDirecion = val?.direction;
            if(ivrDetails && (+ivrDetails?.extension === +val?.extension)) {
                if(this.callLogFG.controls["mode"].value == "IVR" && 
                  val?.call_state === "hangup" && 
                  (val?.phone_number?.replace("+1",'') === this.PhoneNumber) &&
                  ((val?.call_uuid === this.callLogFG?.controls["Identifier"]?.value) || (val?.direction === "inbound"))) {
                      let callTime = this._commonUtil.callTimeDiffernce(val);                      
                      this.callLogFG.controls["callTime"].patchValue(callTime ? callTime.replaceAll(":",'') : null);
                      this.callLogFG.controls["duration"].patchValue(callTime);
                      this.callLogFG.controls["Identifier"].patchValue(val?.call_uuid);
                } else if(this.callLogFG.controls["mode"].value == "IVR" && 
                  val?.call_state === "answered" && 
                  (val?.phone_number?.replace("+1",'') === this.PhoneNumber) 
                  && (val?.direction === "outbound" || val?.direction === "inbound")) {
                  this.callLogId = val?.callLogId;
                  this.callLogFG.controls["Identifier"].patchValue(val?.call_uuid);
                  if(val?.direction === "outbound") {
                    let ivrDetails = { extension:+val?.extension, call_uuid: val?.call_uuid, 
                      direction: val?.direction, phone_number: val?.phone_number?.replace("+1",''), callLogId: val?.callLogId };
                    localStorage.setItem("ivrDetails", JSON.stringify(ivrDetails));
                  }
                }
            }
        }
      });
      this._cmnSvc._miniMizeScreen$.subscribe(val => {
          if(val && !val.miniScreen && this.patientHistRef) {
              this.patientHistRef.close();
          }
      });
  }

  defaultPatchings() {
    this.callModeList = [{id:1, name:'IVR'}, {id:2, name:'Manual'}];
    this.callDirectionList = [{id:1, name:'Outbound'}, {id:2, name:'Inbound'}];
    this.speakingWithList = [{id:1, name:'Patient'}, {id:2, name:'Prescriber'}, {id:3, name:'Insurance'}, {id:4, name:'Pharmacy'}];
    this.insuranceData = this._cmnSvc.insuranceData$["source"]["value"];
    this.maxDate = { year: moment(Date.now()).year(), month: moment(Date.now()).month() + 1, day: moment(Date.now()).date() };
    this.callLogFG = this._fb.group({
      mode: this.IsCallMode ? 'IVR' : 'Manual',
      direction: this.IsOutbondCall ? 'Outbound' : 'Inbound',
      callTime: null,
      duration: null,
      today: this.today,
      recordedDtTm: this._dateCheckUtil.getCurrentDateTime(),
      extension: this.CallLogDetails ? this.CallLogDetails?.extension : '',
      userInitials: this._userServ.getToken("TechUserName") ? this._userServ.getToken("TechUserName") : this.PhUsername,
      userId: this._userServ.getToken("TechnicianId") ? this._userServ.getToken("TechnicianId") :  this._userServ.getToken("UserId"),
      forpatient: this.PatientDetails?.name,
      phoneNumber: this.PhoneNumber,
      reasonCodesId:[],
      reasonCodes:[],
      comments: '',
      speakingwith: this.IsFrom != 'Patient' && !this.IsfromManual ? this.Recipient?.entityName : this.IsfromManual ? 1 : '',
      insuName: this.Recipient?.insuName ? this.Recipient?.insuName : '',
      Identifier: this.InboundDetails ? this.InboundDetails?.call_uuid : '',
    });
    if(!(this.IsEditCallLog || this.IsMaxScreen) && this.IsCallMode){
      let ivrdetails = localStorage.getItem("ivrDetails") ? JSON.parse(localStorage.getItem("ivrDetails")) : null;
      if(ivrdetails && (+ivrdetails?.extension === +this.CallLogDetails?.extension) && 
      (ivrdetails?.phone_number === this.PhoneNumber) && 
      (ivrdetails?.direction?.toLowerCase() === this.callLogFG.controls['direction'].value?.toLowerCase())) {
          this.callLogFG.controls["Identifier"].patchValue(ivrdetails?.call_uuid);
      }
    }
    if(this.IsOutbondCall){
      localStorage.removeItem("ivrDetails");
    }
    this.callLogId = this.InboundDetails ? this.InboundDetails?.callLogId : '';
    if(this.IsEditCallLog || this.IsMaxScreen) {
      let logDetails = this.UpdateCallLogDetails?.logDetails;
      this.callLogFG.controls["mode"].patchValue(logDetails?.callDetails?.mode);
      this.callLogFG.controls["callTime"].patchValue(logDetails?.callDetails?.duration ? logDetails?.callDetails?.duration.replaceAll(":",'') : null);
      this.callLogFG.controls["direction"].patchValue(logDetails?.callDetails?.direction);
      this.callLogFG.controls["duration"].patchValue(logDetails?.callDetails?.duration);
      this.callLogFG.controls["today"].patchValue((this.IsMaxScreen && logDetails?.callDetails?.today) ? this._dateCheckUtil.getCurrentDateWithTime() : logDetails?.callDetails?.recordedDtTm ? moment.utc(logDetails?.callDetails?.recordedDtTm).local().format(MsgConfig.DATE_FORMAT_TIME) : this.today);
      this.callLogFG.controls["recordedDtTm"].patchValue((this.IsMaxScreen && logDetails?.callDetails?.today) ? this._dateCheckUtil.getCurrentDateWithTime() : logDetails?.callDetails?.recordedDtTm ? moment.utc(logDetails?.callDetails?.recordedDtTm).local() : this._dateCheckUtil.getCurrentDateTime());
      this.callLogFG.controls["extension"].patchValue(logDetails?.callDetails?.extension);
      this.callLogFG.controls["forpatient"].patchValue(logDetails?.patient?.name);
      this.callLogFG.controls["userId"].patchValue(logDetails?.callDetails?.userId ?? this._userServ.getToken("UserId"));
      this.callLogFG.controls["userInitials"].patchValue(this.IsEditCallLog ? logDetails?.callDetails?.userInitials : this._userServ.getToken("PhUserName"));
      this.callLogFG.controls["phoneNumber"].patchValue(logDetails?.callDetails?.phoneNumber);
      this.callLogFG.controls["reasonCodes"].patchValue(logDetails?.callDetails?.reasonCodes);
      this.callLogFG.controls["comments"].patchValue(logDetails?.callDetails?.comments);
      this.callLogFG.controls["reasonCodesId"].patchValue(logDetails?.callDetails?.reasonCodesId);
      this.callLogFG.controls["insuName"].patchValue(logDetails?.callDetails?.insuName ? logDetails?.callDetails?.insuName : (logDetails?.InboundDetails?.insuName ? logDetails?.InboundDetails?.insuName : ''));
      this.callLogFG.controls["Identifier"].patchValue(logDetails?.callDetails?.call_uuid ? logDetails?.callDetails?.call_uuid : (logDetails?.InboundDetails?.call_uuid ? logDetails?.InboundDetails?.call_uuid : logDetails?.callDetails?.Identifier));
      this.callLogId = this.UpdateCallLogDetails?.callLogId
      if(this.callLogFG.controls['reasonCodes'].value) {
            const result = this.callLogFG.controls['reasonCodes'].value.map(val => {
              const match = this.callReasonsList?.find(item => +item.reasonId === val.reasonId);
              return match ? match.reasonId : null;
            }).filter(Boolean);
            this.callLogFG.controls['reasonCodesId'].patchValue(result);
            this.isSelectReason = true;
      }
      this.PatientDetails = logDetails?.patient;
      this.Recipient = logDetails?.recipient;
      this.Spcktype = logDetails?.recipient.entityType;
      if(this.IsEditCallLog) {
        this.prescInputValue = false;
        this.clearpatName = logDetails?.patient?.name ? logDetails?.patient?.name : true;
        this.inputValue = logDetails?.recipient?.entityName;
        this.insuName = logDetails?.recipient?.insuName;
        this.callLogFG.controls['speakingwith'].patchValue(this.Spcktype); 
      }
      else if(this.IsMaxScreen) {
        this.prescInputValue = false;
        this.clearpatName = logDetails?.patient?.name ? logDetails?.patient?.name : true;
        this.inputValue = logDetails?.recipient?.entityName;
        this.callLogFG.controls['speakingwith'].patchValue(this.IsFrom != 'Patient' && !this.IsfromManual ? this.Recipient?.entityName : this.IsfromManual ? 1 : ''); 
      } else {
        this.callLogFG.controls['speakingwith'].patchValue(this.IsFrom != 'Patient' && !this.IsfromManual ? this.Recipient?.entityName : this.IsfromManual ? 1 : '');
      }
    }
    if(this.PatientInfo) this.PatientDetails = this.PatientInfo;
    this._cmnSvc._storeCallLogDetails$.next(this.getrequestDetails());
  }

  getCallerReason() {
    this._cmnSvc.getCallerReason().pipe(takeUntil(this.unsubscribe$)).subscribe(resp=> {
        if(resp) {
          this.callReasonsList = resp;
          if(this.callLogFG.controls['reasonCodes'].value) {
            const result = this.callLogFG.controls['reasonCodes'].value.map(val => {
              const match = this.callReasonsList?.find(item => +item.reasonId === val.reasonId);
              return match ? match.reasonId : null;
            }).filter(Boolean);
            this.callLogFG.controls['reasonCodesId'].patchValue(result);
            this.isSelectReason = true;
          }
        }
    });
  }

  cancelModal() {
    this.IsPopUpClosed.emit(false);
    if(!this.IsEditCallLog && !this.IsfromCallLog && !this.IsfromComms)  {
      this._cmnSvc._isCallOngoing$.next(null);
      this._cmnSvc._storeCallLogDetails$.next(null);
      this._cmnSvc._miniMizeScreen$.next(null);
    }
    this._cmmStore._signlrInboundData$.next(null);
  }

  saveCallLog() {
    if(this.PatientDetails?.name && this.Recipient?.entityName && this.callLogFG.valid) {
      if(this.IsfromManual) this.callLogFG.controls['recordedDtTm'].patchValue(this._dateCheckUtil.getCurrentDateTime(this.callLogFG.controls['today'].value));
      if(this.callLogFG.controls['reasonCodesId'].value) {
            const result = this.callLogFG.controls['reasonCodesId'].value.map(reasonId => {
              const match = this.callReasonsList?.find(item => item.reasonId === reasonId);
              return match ? { reasonId: +match.reasonId, description: match.description } : null;
            }).filter(Boolean);
            this.callLogFG.controls['reasonCodes'].patchValue(result);
      } 
      if(this.callLogFG.controls['callTime']?.value) this.callLogFG.controls['duration'].patchValue(this._commonUtil.convertToTimeFormat(this.callLogFG.controls['callTime'].value))   
      this.checkPat = false;
      let reqobj;
      if(this.IsEditCallLog) {
        reqobj = {
            pharmacyDetails: this.UpdateCallLogDetails?.pharmacyDetails,
            applicationDetails: this.UpdateCallLogDetails.applicationDetails,
            logDetails: { patient : this.PatientDetails, callDetails: this.callLogFG.value, recipient: this.Recipient },
            vendorDetails: this.UpdateCallLogDetails.vendorDetails, isActive: this.UpdateCallLogDetails.IsActive, id:this.UpdateCallLogDetails.Id, createdDtTm: this.UpdateCallLogDetails.CreatedDtTm
        }
      } else {
          reqobj = this.getrequestDetails();
      }
      this._cmnSvc.saveCallLog(reqobj).pipe(takeUntil(this.unsubscribe$)).subscribe(resp=> {
          if(resp?.result) {
            this._alrtSvc.success("Call log saved successfully");
            if(reqobj?.logDetails?.callDetails?.direction === "Inbound") this._cmnSvc._closeInboundPopup$.next(true);
            if(this.IsfromCallLog || this.IsEditCallLog) { 
                this.IsPopUpClosed.emit(true);
            }
            else this.cancelModal();
          } else {
            this.cancelModal();
            if(reqobj?.logDetails?.callDetails?.direction === "Inbound") this._cmnSvc._closeInboundPopup$.next(true);
            this._alrtSvc.error("Call log saved unsuccessfully");
          }
      });
    } else { 
      if(!this.PatientDetails?.name) this.checkPat = true;
      this._alrtSvc.error(MsgConfig.ENTER_REQ_FIELD) 
    } 
  }

getPresInsPhrmaDetails() {
  if(this.IsFrom === "Prescriber" || (this.Spcktype === 2 && this.Recipient?.entityId)) {
    this._patPreDrugService._patPreDrugModal$.next("prescriber");
    const modalRef = this._patPreDrugService.modalInstanceRef;
    modalRef.componentInstance.prescriberID = +this.Recipient?.entityId;
    modalRef.componentInstance.ClosePrescriberModal.pipe(takeUntil(this.unsubscribe$)).subscribe(async resp => {
        modalRef.close();
        this._patPreDrugService._patPreDrugModal$.next(null);
    });
  }
  else if(this.IsFrom === "Insurance" || (this.Spcktype === 3  && this.Recipient?.entityId)) {
    this._patPreDrugService._patPreDrugModal$.next("insurance");
    const modalRef = this._patPreDrugService.modalInstanceRef;
    modalRef.componentInstance.insuId = +this.Recipient?.entityId;
    modalRef.componentInstance.CloseInsuModal.pipe(takeUntil(this.unsubscribe$)).subscribe(async resp => {
        modalRef.close();
        this._patPreDrugService._patPreDrugModal$.next(null);
    });
  }
}

getPatientInfo() {
  if(this.PatientDetails?.id) {
    this.ngZone.run(() => {
      const modalRef = this._mdlServ.open(PatientComponent, {
          backdrop: false,
          size: "lg",
          windowClass: "md-xx-lg comp--modal modal-center-to-page modal-patient comp--modal2",
          keyboard: false
      });
      modalRef.componentInstance.patientID = +this.PatientDetails.id;
      modalRef.componentInstance.ClosePatientModal.pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
          modalRef.close();
          if(resp.Type === "Update") { }                           
      });
    });
  }  
}

patientHist() {
  if(this.PatientDetails?.id) {
    this._patPreDrugService._patPreDrugModal$.next("patHist");
      this.patientHistRef = this._patPreDrugService.modalInstanceRef;
      this.patientHistRef.componentInstance.patientID = this.PatientDetails?.id;
      this.patientHistRef.componentInstance.popUpOpenFr = "IVR";
      this.patientHistRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe(closed => {
          if (this.patientHistRef) {
            this.patientHistRef.close();
          }          
          this._patPreDrugService._patPreDrugModal$.next(null);
      });
  }
  
}

selctPresInsPhrm(val) {
  this._cdr.detectChanges();
  let entityName,entityId,entityType;
  if(val) {
    switch(this.Spcktype) {
          case 2:
            entityName = val?.prescriberlastname + "," + val?.prescriberfirstname; 
            entityId = val?.prescriberid; 
            entityType = EntityType.Prescriber;
          break;
          case 3:
              entityName = val?.PlanCode;
              entityId = val?.Id;
              entityType = EntityType.Insurance
          break;
          case 4:
              entityName = val?.PharmName;
              entityId = 0;
              entityType = EntityType.Pharmacy
          break; 
        }
      this.Recipient = { entityName: entityName, entityId: entityId, entityType: entityType }
      }
    else {
      this.Recipient = null;
    }  
}

selectedPatientInfo(patInfo) {
    this.clearpatName = true;
        if (patInfo) {
            this._cdr.detectChanges();
            this.PatientDetails = { name:patInfo?.fullname ? ((patInfo?.fullname).toUpperCase()).replace("_", ", ") : "", id:patInfo?.patientid, dob:patInfo?.dob, phoneNumber:(patInfo?.mobile || patInfo?.telephone), gender:patInfo?.gender, addressLine1:patInfo?.addressLine1, state:patInfo?.state, city:patInfo?.city, zipCode:patInfo?.zipcode }
            if(this.IsfromCallLog && this.callLogFG.controls['speakingwith'].value == 1) {
              this.Recipient = { entityName: patInfo?.fullname ? ((patInfo?.fullname).toUpperCase()).replace("_", ", ") : "", entityId: patInfo?.patientid, entityType: EntityType.Patient }
            }
            this.checkPat = false;
            this._cmnSvc._storeCallLogDetails$.next(this.getrequestDetails());
        } else {
            this.PatientDetails = patInfo;
            this.clearpatName = false;
            if(this.IsfromCallLog && this.callLogFG.controls['speakingwith'].value == 1) {
              this.Recipient = null;
            }
        }
}

formatter = (x: any) => {
    this.insuName = x.InsuranceName;
    this.inputValue = x.InsurerCode;
    return (x.PlanCode ? x.PlanCode : "");
}

  search = (text$: Observable<string>) =>
      text$.pipe(
          debounceTime(200),
          distinctUntilChanged(),
          map(term => (this.filterByPcnBin(term)))
      )

filterByPcnBin(term) {
        if (term && term.length) {
            const insuranceList = Object.assign([], this.insuranceData);
            const filteredData = this._rxUtils.filterInsurancesForSuggest(insuranceList, term);
            this.inputValue = "";
            this.insuName = "";
            this.Recipient = null;
            return filteredData.splice(0, 20);
        } else {
            return [];
        }

    }

  getModDirSpckValue(type,val) {
    if(type === "Mode" && !val) {
      this.callLogFG.controls['mode'].patchValue('Manual');
    } else if(type === "Direction" && !val) {
        this.callLogFG.controls['direction'].patchValue('Outbound');
    } else if(type === 'Speaking') {
        this.Spcktype = val ? val?.id : 1;
        this.callLogFG.controls['speakingwith'].patchValue(this.Spcktype);
        this.insuName = "";
        if(this.Spcktype === 1) {
          this.PatientDetails = { name : (this.RxInfo?.PatFirstName + ',' +this.RxInfo?.PatLastName) , id : this.RxInfo?.patientid }
          this.Recipient = { entityName: (this.RxInfo?.PatFirstName + ',' +this.RxInfo?.PatLastName), entityId: this.RxInfo?.patientid, entityType: EntityType.Patient }
          this.callLogFG.controls["phoneNumber"].patchValue(this.PhoneNumber);
        } else {
          this.PatientDetails = this.Recipient = this.inputValue = this.insuName = null;
          this.callLogFG.controls["phoneNumber"].patchValue('');
        }
    } else if(type === 'Reason') {
      this.isSelectReason = val?.length ? true : false;
    }
  }

  phoneValidationCheck(Phone,event?) {
        if (Phone) {
            if (!this.errorToDisplay && Phone?.length == 10) {
                this._msgServ.ValidatePhone(Phone).pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
                    this.errorToDisplay  = (resp && resp.result)  ? "Valid!" : "Invalid Mobile#";
                    this._cdr.detectChanges();
                    if(event && event.key && event.key == "Tab"){
                    const ele = document.getElementById("callcontact") as HTMLInputElement;
                    if (ele) {
                        ele.focus();
                    }
                    }
                });
            }
        }
  }

  clearTextMsg(phoneNo) {
    if (phoneNo) {
        if (phoneNo?.length < 10) {
            this.errorToDisplay = "";
        } else if (this.errorToDisplay) {
            this.errorToDisplay = "";
        }
    }
  }

  miniMizeScreen() {
    this.IsPopUpClosed.emit(false);
    this._cmnSvc._miniMizeScreen$.next({details:this.getrequestDetails(), miniScreen:true});
  }

getrequestDetails() {
  let reqobj = {
              pharmacyDetails: { identifierType: 'NPI',identifier: this._userServ.getToken("UniquePharmacyId"), name: this._userServ.getToken("PharmacyName"), phoneNumber: this._userServ.getToken("PharmacyPhone") },
              applicationDetails: { applicationId: "1", applicationName: "PrimeRxCloud" },
              logDetails: { patient : this.PatientDetails, callDetails: this.callLogFG.value, recipient: this.Recipient },
              vendorDetails: { vendorId: this.CallLogDetails?.vendorId?.toString(), name: this.CallLogDetails?.vendorName},
              isActive: this.CallLogDetails?.isActive, id:this.callLogId, uniqueId : uuid()
          }
  return reqobj;
}

onValueChange(val) {
  if(!this.isSelectReason) {
    if(val && val.length > 0 && this.callReasonsList?.length > 0) {
        const filteredReasons = this.callReasonsList.filter(item => item.description.toLowerCase() === val.toLowerCase());
        if(filteredReasons.length > 0) {
            this.callLogFG.controls['reasonCodesId'].patchValue(filteredReasons.map(item => item.reasonId));
        } else {
            this.callLogFG.controls['reasonCodesId'].patchValue(["10"]);
        }
    } else {
        this.callLogFG.controls['reasonCodesId'].patchValue([]);
    }
  }
}

ngOnDestroy() {
  this.unsubscribe$.next();
  this.unsubscribe$.complete();
  this._commonUtil.close(this.popupId);
}

}
